<!-- Tier / Corporate — nuevo diseño Figma Modal-2doequipaje-beneficio -->
<ng-container *ngIf="tierConfig; else cobrandTpl">
  <div class="BagsBenefitModal BagsBenefitModal--tier">
    <div class="BagsBenefitModal-close">
      <img alt="cerrar" src="../../../../assets/images/close.svg" (click)="onClose()" />
    </div>

    <div class="BagsBenefitModal-container">
      <!-- Imagen tier -->
      <img
        class="BagsBenefitModal__gift-img"
        src="../../../../assets/images/bag-redention-tier.svg"
        alt=""
      />

      <!-- Título -->
      <p class="BagsBenefitModal__tier-title">
        {{ 'rewardsRedemptionModal.title' | translate }}
      </p>

      <!-- Subtítulo -->
      <p class="BagsBenefitModal__tier-subtitle">
        {{ 'rewardsRedemptionModal.description' | translate }}
      </p>

      <!-- Info nivel: label en línea 1, badge en línea 2 -->
      <div class="BagsBenefitModal__tier-info">
        <span class="BagsBenefitModal__tier-info-label">
          {{ 'rewardsRedemptionModal.tierLabel' | translate }}
        </span>
        <span class="BagsBenefitModal__tier-badge BagsBenefitModal__tier-badge--{{ tierConfig.badgeCssClass }}">
          {{ tierConfig.badgeLabel }}
        </span>
      </div>

      <!-- Disclaimer -->
      <p class="BagsBenefitModal__disclaimer">
        {{ 'rewardsRedemptionModal.disclaimer' | translate }}
      </p>

      <!-- Botones -->
      <div class="BagsBenefitModal-buttons">
        <button class="BagsBenefitModal-btnSecondary" (click)="onClose()">
          {{ 'rewardsRedemptionModal.cancel' | translate }}
        </button>
        <button class="BagsBenefitModal-btnPrimary" (click)="onUseBenefit()">
          {{ 'rewardsRedemptionModal.confirm' | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-container>

<!-- Cobrand — diseño existente sin cambios -->
<ng-template #cobrandTpl>
  <div class="BagsBenefitModal BagsBenefitModal--cobrand">
    <div class="BagsBenefitModal-close">
      <img alt="cerrar" src="../../../../assets/images/close.svg" (click)="onClose()" />
    </div>

    <div class="BagsBenefitModal-container">
      <img
        class="BagsBenefitModal-logo"
        [src]="cobrandConfig?.logo"
        [alt]="cobrandConfig?.nameKey | translate"
      />

      <p class="BagsBenefitModal__tier-title">
        {{ 'bagsBenefitModal.title' | translate : { bankName: cobrandConfig?.nameKey | translate } }}
      </p>

      <p class="BagsBenefitModal__tier-subtitle">
        <ng-container *ngIf="showCarryOnBenefit; else singleBagTpl">
          {{ 'bagsBenefitModal.descriptionWithCarryOn' | translate }}
        </ng-container>
        <ng-template #singleBagTpl>
          {{ 'bagsBenefitModal.description' | translate }}
        </ng-template>
      </p>

      <div class="BagsBenefitModal-buttons">
        <button class="BagsBenefitModal-btnSecondary" (click)="onClose()">
          {{ 'bagsBenefitModal.cancel' | translate }}
        </button>
        <button class="BagsBenefitModal-btnPrimary" (click)="onUseBenefit()">
          {{ 'bagsBenefitModal.confirm' | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
